import { HTMLAttributes, ReactNode } from 'react';
import { ErrorWarning, Check } from '@styled-icons/remix-fill';

import * as S from './styles';
import theme from 'styles/theme';

export interface FormFieldProps extends HTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  name?: string;
  icon?: JSX.Element;
  isValid?: boolean;
  feedbackMessage?: ReactNode;
  type?: string;
}

const FormField = ({
  label,
  required = false,
  isValid = true,
  feedbackMessage,
  icon,
  name,
  type = 'text',
  ...props
}: FormFieldProps) => {
  const icons = {
    error: <ErrorWarning size={24} color={theme.colors.statusDanger50} />,
    success: <Check size={18} color={theme.colors.statusSuccess20} />,
  };

  return (
    <div>
      {label && (
        <S.Label htmlFor={name} aria-required={required} required={required}>
          {label}
        </S.Label>
      )}
      <S.Container>
        <S.Field
          icon={isValid}
          isValid={isValid}
          name={name}
          type={type}
          {...props}
        />
        {feedbackMessage && (
          <S.IconContainer>
            {isValid ? icons.success : icons.error}
          </S.IconContainer>
        )}
      </S.Container>
      {feedbackMessage && (
        <S.FeedbackMessage
          color={
            isValid ? theme.colors.statusSuccess50 : theme.colors.statusDanger50
          }
        >
          {feedbackMessage}
        </S.FeedbackMessage>
      )}
    </div>
  );
};

export default FormField;
